'use client';

import { IconCheckmarkCircleFilled } from '@zillow/constellation-icons/react/filled/icon-checkmark-circle-filled';
import { IconCloseCircleFilled } from '@zillow/constellation-icons/react/filled/icon-close-circle-filled';
import { forwardRef, useContext } from 'react';

import { css, cx } from '@/styled-system/css';

import { Icon } from '../icon/icon';
import { SwitchRootContext } from './context/switch-root.context';
import { switchHandleRecipe } from './styles/switch-handle.styles';
import type { SwitchHandlePropsInterface } from './types/switch-handle.types';

/**
 * @since 10.0.0
 */

export const SwitchHandle = forwardRef<HTMLLabelElement, SwitchHandlePropsInterface>(
  (props: SwitchHandlePropsInterface, forwardedRef) => {
    const switchRootContext = useContext(SwitchRootContext);
    const {
      checkedState = switchRootContext.checkedState,
      size = switchRootContext.size,
      className,
      css: cssProp,
      ...rest
    } = props;

    const styles = css(switchHandleRecipe.raw({ checkedState, size }), cssProp);

    return (
      <span
        ref={forwardedRef}
        data-c11n-component="Switch.Handle"
        data-c11n-version={__C11N_VERSION__}
        className={cx('c11n', 'c11n_switch__handle', styles, className)}
        {...rest}
      >
        <Icon>{checkedState ? <IconCheckmarkCircleFilled /> : <IconCloseCircleFilled />}</Icon>
      </span>
    );
  },
);

SwitchHandle.displayName = 'Switch.Handle';
